import { createAuthProvider } from '@react-keycloak-fork/core';
import { reactKeycloakWebContext } from './context';
export var ReactKeycloakProvider = createAuthProvider(reactKeycloakWebContext);
